import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea } from 'semantic-ui-react';
import Addicon from '../../media/add.png';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Add extends Component {

  state = {
    file: Addicon
  }

  handleFile1 = e => {
    this.updateLocalfile(e.target.files[0]);
    this.insertData(e.target.files[0])
  }

  updateLocalfile(value) {
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({
        file: out
      });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  insertData(file) {
    let context = this;
    let partCode = this.props.partCode;
    var formData = new FormData();
    formData.append('partCode', partCode);
    formData.append('file', file);
    context.setState({
      load: true,
      message: 'Inserting Spare Image!!!'
    });
    $.ajax({
    type: 'POST',
    processData: false,
    contentType: false,
    data: formData,
    url: Server() + 'spares/uploadimages.php',
    success: function(data)
    {
      console.log(data);
      context.props.updateData();
      context.setState({
        file: Addicon,
        load: false
      })
    },
    error: function(error) {
      context.setState({
        load: false,
      });
    }
    });
  }

  render() {
    let { load, message } = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div>
        <input id='nice1' type="file" onChange={this.handleFile1} style={{display: 'none'}}/>
        <label htmlFor='nice1'>
          <Image src={Addicon}
          style={{borderStyle: 'solid', cursor: 'pointer', borderWidth: 1, height: 100}}
          id='image' />
        </label>
        {loading}
      </div>
    );
  }
}

export default Add;
